import updateObject from "../../util/updateObject";
import * as actionTypes from "../dashboard/actionTypes";
import {initialDashboardState} from "./helper";

const initialState = {
    dashboardDetails: initialDashboardState
};
const setDashboardDetails = (state, action) => updateObject(state, {
    dashboardDetails: updateObject(
        state.dashboardDetails,
        {[action.key]: action.value},
    ),
});

const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_DASHBOARD_DETAILS:
            return setDashboardDetails(state, action)
        default:
            return state;
    }
};

export default dashboardReducer;